import { RouteType } from "routes/types";
import { lazy } from "react";

const Element = lazy(() => import("./index"));

const route: RouteType = {
  id: 410,
  parentId: 400,
  name: "DashboardHome",
  label: "Evaluation Tool Home",
  path: "/",
  element: Element,
  user: true,
  admin: false,
  hidden: false,
};

export default route;
